"use strict";
/*******************************************************************************

    Contains a constant of BOSAGORA blockchain

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constant = void 0;
var Amount_1 = require("../common/Amount");
var Constant = /** @class */ (function () {
    function Constant() {
    }
    /**
     * The amount of a penalty for slashed validators
     */
    Constant.SlashPenaltyAmount = Amount_1.BOA(10000);
    return Constant;
}());
exports.Constant = Constant;
//# sourceMappingURL=Constant.js.map